import { Breadcrumbs } from '../../../AbstractElements';
import IconMarkUp from '../Icon-markup';
import { Feather, Icons } from '../../../Constant';
import React, { Fragment, useMemo, useState } from 'react';
import { Container, Row, Col, Card, CardHeader, CardBody, Media } from 'reactstrap';
import * as feather from 'feather-icons';

const FeatherIcon = () => {
  const [iTag, setiTag] = useState('');
  const [feathericon, setfeatherIcon] = useState('');
  const iconNames = useMemo(() => Object.keys(feather.icons || {}), []);

  const getItag = (tag) => {
    setiTag({
      iTag: '<i data-feather="' + tag + '"></i>',
    });
    setfeatherIcon({
      feathericon: tag,
    });
  };

  return (
    <Fragment>
      <Breadcrumbs mainTitle='Feather Icons' parent='Icons' title='Feather Icons' />
      <Container fluid={true}>
        <Row>
          <Col sm='12'>
            <Card>
              <CardHeader>
                <h5 className='m-b-0'>
                  <span className='digits'>{Feather}</span> {Icons}
                </h5>
              </CardHeader>
              <CardBody>
                <Row className='icon-lists feather-icons'>
                  {iconNames.map((icon) => {
                    const iconSvg = feather.icons?.[icon]?.toSvg?.(icon) ?? '';
                    return (
                      <Col sm='6 col-12' xl='4' key={icon} onClick={() => getItag(icon)}>
                        <Media>
                          <div dangerouslySetInnerHTML={{ __html: iconSvg }} />
                          <Media body className='align-self-center'>
                            <h6 className='mt-0'>{icon}</h6>
                          </Media>
                        </Media>
                      </Col>
                    );
                  })}
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
      <IconMarkUp itag={iTag} icons={feathericon} />
    </Fragment>
  );
};

export default FeatherIcon;
